import { Suspense } from "react"
import { useTranslation } from "react-i18next"

import { AccessManagementTabs } from "@/components/access-management/tabs"
import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"

export function AccessManagementPage() {
  const { t } = useTranslation()

  return (
    <Suspense fallback={<div>{t("common.loading")}</div>}>
      <main className="flex w-full flex-1 flex-col">
        <Header>
          <AppBreadcrumb
            links={[
              {
                href: FRONTEND_ROUTES.DASHBOARD.href,
                label: t("sidebar.dashboard"),
              },
              {
                label: t("sidebar.accessManagement"),
              },
            ]}
          />
        </Header>
        <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
          <h1 className="page-title">{t("pages.accessManagement.title")}</h1>
          <AccessManagementTabs />
        </section>
      </main>
    </Suspense>
  )
}
